// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3vzzn","right":"styles_right__f_vwS"};